export default "__VITE_ASSET__CvqDh431__"